"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * When it comes time to delete the "With Tags Query" aka getting rid of the feature flag,
 * delete this predicate along with the associated queries and it should be more obvious where changes need to be made.
 * feature flag name: catalogTagsEnabled
 * */
function isColumnWithTags(column) {
    return column.tags !== undefined;
}
exports.isColumnWithTags = isColumnWithTags;
function isTableColumnsWithTags(column) {
    return column.tags !== undefined;
}
exports.isTableColumnsWithTags = isTableColumnsWithTags;
//# sourceMappingURL=FeatureFlagPredicates.js.map